import {createReducer, on} from '@ngrx/store';
import {Company} from '../../../model/proposal/company';
import {CompanyPageActions, MyCompanyActions} from '../actions/company.actions';
import {CompanyPage} from '../../../model/company-page';


export const companyFeatureKey = 'company';

export interface CompanyAppState {
  [companyFeatureKey]: CompanyState;
}

export interface CompanyState {
  myCompany?: Company;

  companyPage?: CompanyPage;
  loading: boolean;
  error: Error;
  memberPosterView: boolean;
}

export const initialState: CompanyState = {
  loading: false,
  error: undefined,
  memberPosterView: true
};

export const reducer = createReducer(
  initialState,

  on(MyCompanyActions.errorLoading, (state, {error}) => ({
    ...state,
    error: error,
    loading: false,
  })),
  on(MyCompanyActions.notFound, (state) => ({
    ...state,
    myCompany: undefined
  })),
  on(MyCompanyActions.load, (state) => ({
    ...state,
    loading: true,
  })),
  on(MyCompanyActions.loaded, (state, {company}) => ({
    ...state,
    myCompany: company,
    loading: false,
  })),
  on(CompanyPageActions.load, (state) => ({
    ...state,
    loading: true,
  })),
  on(CompanyPageActions.loaded, (state, {companyPage}) => ({
    ...state,
    loading: false,
    companyPage: companyPage
  })),
  on(CompanyPageActions.errorLoading, (state, {error}) => ({
    ...state,
    error: error,
  })),
  on(CompanyPageActions.memberPosterView, (state, {memberPosterView}) => ({
    ...state,
    memberPosterView: memberPosterView
  }))
);

